<template>
  <el-dialog title="微课预览" :visible.sync="dialogVisible" width="80%" top="10px">
        <iframe class="page-img" :src="imgs" frameborder="0"></iframe>
  </el-dialog>
</template>

<script>
export default {
    props:['boardId'],
  data() {
    return {
      dialogVisible: false,
      pages:[],
      imgs:'',
    };
  },
 
  methods: {
    
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async writingDetail(){
        const res = await this.$axios.post("/base/board/detail",{
            board_id:this.boardId,
        });
      if (res.status == 200 && res.data.errCode == 0) {
          this.pages = res.data.data.pages
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
  watch: {
    boardId (newName, oldName) {
        this.boardId = newName
    }
}
};
</script>

<style lang="scss" scoped>
.page-img{
    width: 100%;
    // height: 100%;
    height: 540px;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/kejian/detail.vue